<div class="usa-modal__content">
    <div class="usa-modal__main"  style="width:100%;height:100%">
        <h2 class="usa-modal__heading" id="modal-1-heading">
            DocuSign
        </h2>
        <div style="width:100%;height:100%;">
            <iframe
                    #iframeRef
                    *ngIf="safeUrl"
                    [src]="safeUrl"                  
                    frameborder="0"
                    style="border:none;width:100%;height:600px;"
            >
            </iframe>
        </div>
       <!--<div *ngIf="embeddUrl" [innerHTML]="iframeHTML"></div>-->
        
    </div>
    <button class="usa-button usa-modal__close" aria-label="Close this window" data-close-modal (click)="bsModalRef.hide();makeSelection('hide')">
    <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
      <use xlink:href="/assets/uswds/img/sprite.svg#close"></use>
    </svg>
  </button>
</div>